import { useEffect, useRef, useState } from "react";

// Telt vloeiend op van 0 naar `value` (voor XP/munten op het resultaatscherm).
export function CountUp({ value = 0, duration = 900, delay = 0 }) {
  const [n, setN] = useState(0);
  const raf = useRef(null);
  useEffect(() => {
    const target = Number(value) || 0;
    let startTs = null;
    const tick = (ts) => {
      if (startTs == null) startTs = ts;
      const p = Math.min((ts - startTs) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(target * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    const to = setTimeout(() => { raf.current = requestAnimationFrame(tick); }, delay);
    return () => { clearTimeout(to); cancelAnimationFrame(raf.current); };
  }, [value, duration, delay]);
  return <>{n}</>;
}
